module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_20.0fb44036.jpg";